const BASE_URL = 'https://func-octolytics-dev.azurewebsites.net/api'


/*
export const TOKEN_SING_IN = 'Ky308lKQVsoKsRUNYarX5/jJbXC19uBHzXeFyNPaY8hCh4qUaclecg==';

export const TOKEN_CREATE_BASE_STATION_CSV = 'yo65LJxxz8mG3kgeXvHg6rMkLMgpIxzBmBOjB2blamXaKpIhM9FSzQ==';

export const TOKEN_CREATE_BASE_STATION = 'EGRNf/2Cj1zPDt76CEhp/mdBVhSwbOzIQaxO727maHGGYbGfUnkvJw==';

export const TOKEN_CREATE_DEVICE_LIST = 'AtM4ItLbiOwtA5LvYIy87v4MEn4ZOEGnTaFUbzXWeIMljUh1bDYR0Q==';

export const TOKEN_REPORT = 'GamOwejuFf7vgkNaZ4jJbMhLaKaLaizs7nEBmOws37VPVLkx1CEdxA==';

export const TOKEN_GET_BASE_STATION = 'w1tizlnVOuxMTTZagTSobrdHBcrUs62NaG3WaYMPaze1KMzw7Fsh1w==';

export const TOKEN_GET_DEVICES = 'U7YPENFli3dr7apie8ahh6gfw/1zhdHmi7OVpcVmIx/aL3JbC4HGSA==';

export const TOKEN_GET_DEVICES_LIST = 'vM4Yl6aUoqopvQLd//LIQFiEYijT0f/RZGDRonuuVKPcXlnDwzOVsw==';

export const TOKEN_GET_DEVICES_LIST_BY_ID = 'i0wqq3DJiGVxsEOhsv9LkeevDQ9THiqVNF9nhA0SwofZ0QowK0Mjaw==';

export const TOKEN_GET_KPIS = 'nAn1z2uAyTaQ9p/MeY4Zjg2CirYKpdBnJOhUVKrJ4HUxBbxHKUy92w==';

export const TOKEN_GET_REPORT_BY_ID = 'P1eIhkotBEPEDAIhcJD6aJHpWkUQ8uB8PBcYuyWMMekJe5yhA9TvbA==';

export const TOKEN_GET_REPORTS = 'Bc2GLaTCG2VLbnH1ciyLt2PUA3DaLCpfdOmbM4NiaMLFp/REjuResw==';

export const TOKEN_UPDATE_BASE_STATIONS = 'fVvfyROyiwd6anyiQVSFYui9GgTm0xGUTBdlU6u1sc4w/9y7dZa8Fg==';

export const TOKEN_GET_DEVICES_BRAND = '';

export const TOKEN_GET_GEOFENCING = '';

export const TOKEN_GET_GEOFENCING_BY_ID = '';

export const TOKEN_CREATE_GEOFENCING = '';

export const TOKEN_UPDATE_GEOFENCING = '';

export const TOKEN_DELETE_GEOFENCING = '';

export const TOKEN_CREATE_NOTIFICATION = '';

export const TOKEN_UPDATE_NOTIFICATION = '';

export const TOKEN_DELETE_NOTIFICATION = '';

export const TOKEN_INCIDENTS_BY_DATE = '';

export const TOKEN_NOTIFICATION = '';

export const TOKEN_NOTIFICATION_BY_DATE = '';

export const TOKEN_SEARCH_KPIS = '';

export const TOKEN_GET_TICKETS = '';
*/

/*
// Octolitycs QA

export const TOKEN_CREATE_BASE_STATION = '/aBQIYIghIeiwApi9A7xXGuGKE28MvbfZrtP7tqK/fcBVx6SM3qKyA==';

export const TOKEN_GET_BASE_STATION = 'dMDh157zuhECVocKDG8WiuaqBJSK7d5J2qRjUgAaci9oC/ha8U43vw==';

export const TOKEN_GET_DEVICES = 'ax1cL5zvH7lBu6gfEKb71WQS20uxFnrFpga6UMHo9zSQxagA13Fqaw==';

export const TOKEN_GET_DEVICES_LIST = 'XHvk2B0clHJgwtMB3p6rNIPpIuG9hGDEQaJ1dBReg7097KH4lctg9g==';

export const TOKEN_GET_DEVICES_LIST_BY_ID = 'JhSt3Dq6SyFIaSaFv9FN3mLPWaCaIm9H8pnGcGMcZbPptls7qT2K3g==';



export const TOKEN_GET_DEVICES_BRAND = 'MVY41GGGAJzGPYB9Fj6TsT9CUaIXGadL2W10R4KmKbiNOvlEIpYhbw==';

export const TOKEN_GET_GEOFENCING = 'WuT9d1213g5FN7276/A6W1nrdgsAlTuJIUN6qDZGd2uFc3D/MdPS7g==';

export const TOKEN_GET_GEOFENCING_BY_ID = 'jdU2aAAaVAvkOtegsc0j1oj/xBswwfA2QWsBBZhXt1OnE6smB2XCFA==';

export const TOKEN_CREATE_GEOFENCING = 'WPq2naacm5sktQfCJqUDDtEaE8dYbwiSp5pCuLq07aMe3aBub8DKnw==';

export const TOKEN_UPDATE_GEOFENCING = 'sndJUzx3jVwF1AsTV4xD4047XP8BZyAPyvz/SdXYmqnKkumR3ZIoIg==';

export const TOKEN_DELETE_GEOFENCING = 'axe9wMNlDoe8Z7EfnrFuzWXVfXhTCuxVJaTg2OFtIYNKQyzPrgaibw==';

export const TOKEN_CREATE_NOTIFICATION = 'PSFcOZ8URohZxEJQKhbEyejKaveA83srXZMN15eOpCQoeQm3n2AkTQ==';

export const TOKEN_UPDATE_NOTIFICATION = '0joQGK4Dt/3I74qLBLBfaM9BdzJ9ci5u02JkGy1fTgaVBPocNFTtww==';

export const TOKEN_DELETE_NOTIFICATION = 'B0ezCBvhnx3B14DUvJ0PDHaANUyCMww5VVUmmjZe7Xm09wNN/JEhIg==';

export const TOKEN_INCIDENTS_BY_DATE = '/tTDixQybuJ7gucNh4o2PIpdEok4OLDrtzrH4wa9pCOtP/6LbKCwpw==';

export const TOKEN_NOTIFICATION = 'rHZbF9IuMj0yQ/baNFX4CTSqoRTqmuQYERWYO1YgiSd2qN6NaqE57A==';

export const TOKEN_NOTIFICATION_BY_DATE = 'ASABtEf7qk7IaJO9zguSamHDPvDtzqojURaB4akDLDA0jQ5/RG5LZw==';

export const TOKEN_SEARCH_KPIS = '';

export const TOKEN_GET_TICKETS = '';
*/


/*
// Dr. Mi Móvil

export const TOKEN_SING_IN = '/WbeQtqOkca/PzL1P/I8ndufGNye1BNaWORPr9cgWIZAtKXs0VI90w==';

export const TOKEN_CREATE_BASE_STATION_CSV = 'L8jIeX4pSY21FjCLPOPru7UWi6LW2Ns5R18n4RF59OS3RgOaL83oQw==';

export const TOKEN_CREATE_BASE_STATION = 'z9299pI3yHWiJ4PfV3fr0a9WeBKttakcrOkadM8od4rm8SxyYhBfKQ==';

export const TOKEN_CREATE_DEVICE_LIST = 'Mi5xONvo6TYNiOZslVFa9Nj0oQ9G5lIQFSuatpPbck7v2gAd9JlgUA==';

export const TOKEN_REPORT = '0gPkdrN4p4peNr4kMChI3rdQ8TUhHK5BYdK8OlPtpqDdEv1u3oLZEw==';

export const TOKEN_GET_BASE_STATION = 'MGddFaH8qv3VEEErgmQRtocdc21GulTjn9/bi0TCP8iSfA9zT8TZ2Q==';

export const TOKEN_GET_DEVICES = 'MZW3z8wL2XLiTnYJJlyss1CssL5ZUw/WUo53mj0fE6uAU7YKBEatfQ==';

export const TOKEN_GET_DEVICES_LIST = 'lfjV6XlO54HSDx4/N4rbYfSAyYR4JSCwnz9BQJ6RToPHjY/NuNeAQg==';

export const TOKEN_GET_DEVICES_LIST_BY_ID = 'C68cUBboiqWSSv/pczOrs2S1wgRBqJKfvMs9aokrqdr4TqTHSk2i2w==';

export const TOKEN_GET_KPIS = 'EpjYdkqXsnQjepYamHv5n/S6c2aKHk1pxjANlJCxMMdFIh2CJ9v21w==';

export const TOKEN_GET_REPORT_BY_ID = 'NpOvpOS2wl5vthZr0FC/Zjtxd3Lrh5a7JvJFi9Tvgz5rSpdWipA5Og==';

export const TOKEN_GET_REPORTS = 'YhhExhduwHPlmD0cTnOrZeeKX0hGQ0SRBlBhJAX2gkwNVfc1nyPXEQ==';

export const TOKEN_UPDATE_BASE_STATIONS = 'RlYNzchOYhGjWki2/Z1IVvzkLH9aakM2W94q8JJrL7PG3I0aMCgOxQ==';

export const TOKEN_GET_DEVICES_BRAND = 'DkXfj4/17DONCK3WfAUbzY7cYgzaMhiQG7ue5XPa0fYGnsfmINXWNg==';

export const TOKEN_GET_GEOFENCING = 'Db9tgaWWhd5lY0QyeVetpSXAKfC91DMNGfBpJ86/yCazYJ1l4da4lw==';

export const TOKEN_GET_GEOFENCING_BY_ID = 'z73u1lHanPsj2wqLRWoFhWkH5AOhxQPxzo/8LOFMTexhqaNy65GF5A==';

export const TOKEN_CREATE_GEOFENCING = 'nVXsqi43opggCrnWgvGrxlYcGJU5zCD99BcY2hL8QFcyLvr8bhfonA==';

export const TOKEN_UPDATE_GEOFENCING = '0Cnl97NFd6S13fr28RaFGmBOxCv9t29cfYpo9gn2Jfco9V5T7gQmnQ==';

export const TOKEN_DELETE_GEOFENCING = 'PwSZasJbzGq1M97BaEo3ArvTQbDxs86/GaCaH5sxeIborlgpV/f06g==';

export const TOKEN_CREATE_NOTIFICATION = 'j8/7pkkHWCdkvGkDFDaVhZwZy1cRIb2WaepmVES/c8noPKsSPGYKtg==';

export const TOKEN_UPDATE_NOTIFICATION = 'djfHACM2OCssk3Nch2jkK54TqTCcWjQk7w3paEORNXtehIV1aX4DSw==';

export const TOKEN_DELETE_NOTIFICATION = 'RmfMMiaLn58nwJXkXOyQG/UnAU2J6oPAH1gx1oJuOnO8xqBTrBWPiQ==';

export const TOKEN_INCIDENTS_BY_DATE = '92U2Chu1zEq/axBTeEKDA8CPcxFiAce0E2H/kN9aoEreiMvSmX87rQ==';

export const TOKEN_NOTIFICATION = 'xnRs5ca9jOKa4JeP0Scw05Y8pQP34YtK5Lbnu8zvI60UcRzbluNvjg==';

export const TOKEN_NOTIFICATION_BY_DATE = 'eM8lXgGogIkd0O6OASN45Y2CzhkAbmVAJXrL5ADpStat1s1d52G3IQ==';

export const TOKEN_SEARCH_KPIS = 'HPse1jXmnlGOOWFJHumgqMGBTxNXavBp8EDS56aVcYkn7Nt6MrdArw==';

export const TOKEN_GET_TICKETS = 'Pc1aX9uzt00476ZlsNTUTSArYhKAqBU5VX0fwptUfnjQMgtRNxoyQQ==';
*/


// Dr. InXel
/*
export const TOKEN_SING_IN = 'GRp6C8u0tIoG2zoN0pdUZcP1kR6xMNhZTDYfRApYwgJOv65NlRnnVA==';

export const TOKEN_CREATE_BASE_STATION_CSV = 'DvaY6RD9s/8y8jyPdIYvaJ3390EcVtdcsVIH1wxNGjcaJNUuMO5QIQ==';

export const TOKEN_CREATE_BASE_STATION = 'v7y/v0aC2Wx1MG4u6ZSNXDpSoNSX8EleyEayaOx9ZPM2znuRg1ucBw==';

export const TOKEN_CREATE_DEVICE_LIST = '3wvKpUtjebAdDOy5AbLNNp6QkdqvBQSGQ8YUXY5jhjXERmjDrV7NOg==';

export const TOKEN_REPORT = 'xQKBeHPa85Tz/qp26jY0rBfXZmoO/4KVC4ESoUeslZjGHaq9UH/FOA==';

export const TOKEN_GET_BASE_STATION = 'ij0Jj1Y2uydMtKlyXZqBsb5MNsqx2KUaNa4SskguwzFMSmBRiu57Ag==';

export const TOKEN_GET_DEVICES = '9b6y1WLnaKXB2sojsyBqNSqmHPOjsFawapRXVOdXnZ2Sq6HydWMJPA==';

export const TOKEN_GET_DEVICES_LIST = 'Y7aDzadkuicD8YmWctWkiDNOF58mCIsECDDkebUJOnq8TXReV5AEyw==';

export const TOKEN_GET_DEVICES_LIST_BY_ID = '5f/PHPgu64RqyuVbqPWogQ8Z6SMD7qa56YVBapp4zaC8a9RBIiBlIQ==';

export const TOKEN_GET_KPIS = 'al5ocyx/opHyz1gbwDld3i0g4UQ4ZXaw8hevf2jwQUaomHO65VfcQQ==';

export const TOKEN_GET_REPORT_BY_ID = '/z9M8gXosval7LN1qiPOEfebhV5oz/i5JlJEZhMaki189a6la4UIcA==';

export const TOKEN_GET_REPORTS = 'eakQtWrjzLhaEfJW3xZ2xxnhXzcD41MGERZ0tDCnI15NGT3ap9/CiA==';

export const TOKEN_UPDATE_BASE_STATIONS = '7ngOngY405FXmIsB4YkWRnJITKgyVaqZMR7iAGIP9ysEQaYebI44SQ==';

export const TOKEN_GET_DEVICES_BRAND = 'zxTbs2aAaQaasQj0H9FkZtcnadlDlP2p3am4gCbTgi95uk4u3bGS7A==';

export const TOKEN_GET_GEOFENCING = '4jQkLszf22nf9a1242t9TLDGrfWRJanAM/LYfq6JgEYkrgclrEMe3A==';

export const TOKEN_GET_GEOFENCING_BY_ID = 'k43NVStAq/0yB6PPS6hqhZazIpr99EmV9HPHkX8hmMYk9a8CMWaNJQ==';

export const TOKEN_CREATE_GEOFENCING = '34JlYsDx0ax/tDdbBLeMN4YOLZ34yOlywFzWevEVKtZCPahfTIgpyw==';

export const TOKEN_UPDATE_GEOFENCING = 'Gyc/RIfrUq9ExT5GgtrO3paqz2bU45H35KJgSjj2kuYbds22FWrxHQ==';

export const TOKEN_DELETE_GEOFENCING = '2aBFutfRfo1tGN5QbDtl2X3rY8Y4gUw7OIsAIE7jfmEOpjy0Io1kYg==';

export const TOKEN_CREATE_NOTIFICATION = 'hBkkFtmLtQpiuisLzWuMq7obGuP7SqhwlVEQUFJJqJsCUQCLZpc0Mg==';

export const TOKEN_UPDATE_NOTIFICATION = 'goivTXkrASnHkDWqq4sG8z6vJbsyQt8iHjvu5/PbiaHjakwNVKpalA==';

export const TOKEN_DELETE_NOTIFICATION = 'BO3hog/fWKcZDSI3YYlCO8vHlyCO08KMnbUHQ/XIgfGrY2Q2kPVR7A==';

export const TOKEN_INCIDENTS_BY_DATE = 'S7hAQI9Xs0C1MAjn03DO0FdAjymmHzHbJ8cum6/xEICwpEU04zanOA==';

export const TOKEN_NOTIFICATION = 'LN6aJ3aLT/hx469I5Jthwq186aV3E90NOKwmB6NQa901PSDJ7osstA==';

export const TOKEN_NOTIFICATION_BY_DATE = 'qPLcKlHcQAbiG0j8Oq0aYtyl1yHSEbN4H7jdy5ZaS6KGerZcNpQtSw==';

export const TOKEN_SEARCH_KPIS = 'aH7oELMaCju43QaelPSQRO0kV8/tj6EhifMaUllDMYD14HjC1t2Wbw==';

export const TOKEN_GET_TICKETS = 'kCA3ga7VDMRMzcTcEMCQaMseAZpSjhBIK9mcHIi8VRFHkFkOkru5EA==';

export const TOKEN_GET_INCIDENTS_BY_DEV = '-2tMc4qK_vKmy1S0S800xwjM2hm6UtILsolVW2uS76WaAzFuph6HPQ==';
*/


// Dr. Mexfon

export const TOKEN_SING_IN = 'NJHx8_cN_hnVxTP489iIkGhr-HP15-54tvuY6PhlQ6YRAzFurkmtPw==';

export const TOKEN_CREATE_BASE_STATION_CSV = '8q-5cwlzB6-Y4JTr08VYbBk-lPkcWazgxZ7baOAMTkI-AzFuP3e4Ow==';

export const TOKEN_CREATE_BASE_STATION = '49vYS-EJz0E8gEFdV0Kn0zfWuobrjYSWjhBuwHACEDx4AzFuGfqHCg==';

export const TOKEN_CREATE_DEVICE_LIST = '1VK2DoGXQbUcJ97Sme88P2ru-8_WCHCDDnSiQrA92j41AzFu8ZIkiA==';

export const TOKEN_REPORT = 'O7w2XXPXmsarYNvUiwSNwPCVe7hv2Nt-MflEGC2DQuzxAzFujQWWHg==';

export const TOKEN_GET_BASE_STATION = 'Lp4vCm1XqmKHQvy3UaJiWeR58v_pR7uQVCEzn5492ycAAzFu_LCx1w==';

export const TOKEN_GET_DEVICES = '1Grc6jp8DBJKkOLhqb0AAzLfFXfGy99dMDNDz23PiHWAAzFu8FNjdQ==';

export const TOKEN_GET_DEVICES_LIST = 'e-3ppW-nYBnYNd6n1yhWToWHEZgzXQXJOJNfmyEGVAlwAzFuLZll1g==';

export const TOKEN_GET_DEVICES_LIST_BY_ID = '6bpUuYJ1sQ2t3XJhJBDCV29lZZZ6o9P5N0Gawg91-i-GAzFuBPg2UQ==';

export const TOKEN_GET_KPIS = '14YdDZEATJJ9RZ5JJlZtWTUr5xURFVczrx8EWNIhpXs1AzFu4CWxVA==';

export const TOKEN_GET_REPORT_BY_ID = 'NM1JwogrwXh_YpTbaz7H8opaPxNZqGuXuxejPoXGvLZIAzFugX3CsA==';

export const TOKEN_GET_REPORTS = 't4mxlZ2iIV6MmrtwKzGPUJx6HhljskMWIfL4z_ZxuPz0AzFuAMO6DQ==';

export const TOKEN_UPDATE_BASE_STATIONS = 'q8mdLFwzUiV3tWJhDixXVj41RLZnfu1XO8-34Uxj_Dm_AzFudrG0Ug==';

export const TOKEN_GET_DEVICES_BRAND = 'cItNEN6JLpKpa2dueOObrgGlMMsKHNknZeVK7LmZ9h1jAzFuD87HAA==';

export const TOKEN_GET_GEOFENCING = 'gmXXpflUqlVcdLi0SxZRwA72HMhrFUdXjOgYpVdeUKEVAzFuuTzT7A==';

export const TOKEN_GET_GEOFENCING_BY_ID = 'xXbW-Anktqh9EBAad_YwSb8W7q1RfI_uqwcsK2iT9wJhAzFuigDjyg==';

export const TOKEN_CREATE_GEOFENCING = 'HBam-ilMLcHq5tp7R9q8EOhv6cxQVmeT5RN6TauJnwOkAzFujzbcMQ==';

export const TOKEN_UPDATE_GEOFENCING = 'W33_n0xOJF4SNeSEisiZd_ITkOI37u7RzTNjIqyNvNcyAzFuT5bx0g==';

export const TOKEN_DELETE_GEOFENCING = '7QhVB-yEtr8KC37q1lBUOcW9JTQMfB6CbEUIF80cBJzxAzFuiywzzQ==';

export const TOKEN_CREATE_NOTIFICATION = 'IOSxhZhZY8TH163jGwTCQlYxvrNEJHQBs4j_kEx8i13mAzFupgrJyA==';

export const TOKEN_UPDATE_NOTIFICATION = 'iHW6l3CeOHDDfUoH2G0wU4JjEXjpGUWasrbnhPoP_GyRAzFuUJnJKA==';

export const TOKEN_DELETE_NOTIFICATION = 'eOYra1W_H7rsWX77tmdb1mzvaKUFqiUFBbVA4TkNhHHcAzFu5cYmWg==';

export const TOKEN_INCIDENTS_BY_DATE = 'zdHdN89DRxbBUoN5mVVGqlxkXjAy-2v1P7qJpWMMzrV_AzFuEgAWCQ==';

export const TOKEN_NOTIFICATION = 'La8OHXJedmIa_KIvVov8JSTGv6dCVCzLtTPfWkEEFjphAzFuQmmj3Q==';

export const TOKEN_NOTIFICATION_BY_DATE = 'PJ4PNUvlm2ELu2zEjpRf-K9aKlC6T3K37mtExsGu3oI4AzFuMw38xA==';

export const TOKEN_SEARCH_KPIS = 'CfbdE6i46om_B9Yg1n-Qq4P-Jsj3dAyMWGU8l5PqgZwBAzFuQuk6Yg==';

export const TOKEN_GET_TICKETS = 'O3_EJjMuGodheKXRpxYeDeRNDQmhY09FW4y68n8KQm7SAzFuZkDN8g==';

export const TOKEN_GET_INCIDENTS_BY_DEV = 'gM2uNdYpVdQdOTf3B78aA7X1uVviHSyJymgl9gFxLzcmAzFu54MX5Q==';
